import { Box, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import React from 'react'

import UploadStatusListInstance, { UploadStatusListProvider } from '../../../store/uploadstatuslistdialog.store'
import AdmissionExamStoreInstance, { AdmissionExamStoreProvider } from '../../../store/admission-exam.store'
import ApiProviderStoreInstance, { ApiProviderStoreProvider } from '../../../store/apiprovider.store'
import AnalyticsStoreInstance, { AnalyticsStoreProvider } from '../../../store/analytics.store'
import HybridClassVideoUploadStoreInstance, { HybridClassVideoUploadStoreProvider } from '../../../store/hybridclassvideoupload.store'
import DownloadStatusListDialog from '../../study-material-components/DownloadStatusListDialog'
import UploadsStatusList from '../../online-course-components/UploadsStatusList'
import UploadProgressTray from '../../../alive-academics/components/admin/hybrid-class-videos/UploadProgressTray.jsx'
import { useLayoutContext } from '../../../contexts/layout.context'
import aliveLogoImg from '../../../assets/alivelogo.png'
import SideDrawer from './AdminSideDrawer'
import Navbar from './AdminNavbar'


const Layout = ( { navHeadText } ) => {

    const { navHeight, setMenuState, minSidebarCollapseWidth } = useLayoutContext()

    const { palette, theme } = useTheme()

    const handleResizeOrLoad = () => window.innerWidth < minSidebarCollapseWidth ? setMenuState( false ) : setMenuState( true )

    useEffect( () => {
        window.addEventListener( 'resize', handleResizeOrLoad )
        window.addEventListener( 'load', handleResizeOrLoad )
        return () => {
            window.removeEventListener( 'resize', handleResizeOrLoad )
            window.removeEventListener( 'resize', handleResizeOrLoad )
        }
    } )

    return (
        <AnalyticsStoreProvider store={AnalyticsStoreInstance}>
            <ApiProviderStoreProvider store={ApiProviderStoreInstance}>
                <UploadStatusListProvider store={UploadStatusListInstance}>
                    <HybridClassVideoUploadStoreProvider store={HybridClassVideoUploadStoreInstance}>
                        <AdmissionExamStoreProvider store={AdmissionExamStoreInstance}>
                            <Box flexDirection={{ sm: "row", xs: "column-reverse" }} bgcolor={palette.layoutBackground} display="flex" height="100%" overflow="auto">
                                <SideDrawer closeSideMenu={() => setMenuState( false )} />
                                <Box
                                    flexGrow={1}
                                    display="flex"
                                    flexDirection="column"
                                    minWidth="0"
                                    position="relative"
                                    overflow="auto"
                                >
                                    <Navbar navHeadText={navHeadText} closeSideMenu={() => setMenuState( false )} openSideMenu={() => setMenuState( true )} />
                                    <Box
                                        bgcolor={palette.background.default}
                                        overflow="auto"
                                        borderRadius={{ sm: "10px 0 0 0", xs: "0" }}
                                        flexGrow={1}
                                        display="flex"
                                        id="page-content"
                                        className={theme}
                                        minWidth="0"
                                        position="relative"
                                    >
                                        <Box position="absolute" sx={{ zIndex: 100, inset: 0, opacity: "0.1", pointerEvents: "none" }} height="100%" display="flex" alignItems="center" justifyContent="center"  >
                                            <Box component="img" sx={{ opacity: "0.4" }} width="30%" src={aliveLogoImg} />
                                        </Box>
                                        <Outlet />
                                    </Box>
                                </Box>
                                <DownloadStatusListDialog />
                                <UploadsStatusList />
                                <UploadProgressTray />
                            </Box>
                        </AdmissionExamStoreProvider>
                    </HybridClassVideoUploadStoreProvider>
                </UploadStatusListProvider>
            </ApiProviderStoreProvider>
        </AnalyticsStoreProvider>
    )
}

export default Layout
